import { atom } from "recoil";
const tokenState = atom({
  key: "token",
  default: null
});

export { tokenState };